// File: components/ui/Notification.jsx
import React, { useEffect } from 'react';
import Icon from '../appIcon';

const Notification = ({ message, type = 'info', onClose, duration = 5000 }) => {
  useEffect(() => {
    if (duration) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [duration, onClose]);

  const bgColor = type === 'error' ? 'bg-red-500' : 'bg-green-500';
  const icon = type === 'error' ? 'AlertCircle' : 'CheckCircle';

  return (
    <div className={`fixed top-4 right-4 z-50 px-4 py-3 rounded-md shadow-lg ${bgColor} text-white`}>
      <div className="flex items-center">
        <Icon name={icon} size={20} className="mr-2" />
        <span>{message}</span>
      </div>
    </div>
  );
};

export default Notification;